import { render, staticRenderFns } from "./MobileTutorial.vue?vue&type=template&id=120492c8&scoped=true&"
import script from "./MobileTutorial.vue?vue&type=script&lang=js&"
export * from "./MobileTutorial.vue?vue&type=script&lang=js&"
import style0 from "./MobileTutorial.vue?vue&type=style&index=0&id=120492c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120492c8",
  null
  
)

export default component.exports